import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ConnectModal from "../Connect Wallet/ConnectModal"
import SetPassword from "../Connect Wallet/SetPassword"
import { useSelector, useDispatch } from "react-redux"
import {
  clearUser,
  setActiveToken,
  setEvmKey,
  ActiveNetwork,
} from "../redux/userSlice"
import axios from "axios"

const SideNavbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data } = useSelector((s) => s.user)

  const toggleNavbar = () => setIsOpen((o) => !o)
  const handleNavigate = (path) => {
    navigate(path)
    setIsOpen(false)
  }

  const handleLogout = () => {
    dispatch(clearUser())
    dispatch(setActiveToken(null))
    dispatch(setEvmKey(null))
    dispatch(ActiveNetwork(null))
    localStorage.removeItem("token")
    localStorage.removeItem("passwordVerified")
    toast.success("Logged out", { position: "top-right", autoClose: 2000 })
    setTimeout(() => {
      navigate("/")
      setIsOpen(false)
    }, 300)
  }

  const handleWalletClick = async () => {
    setIsOpen(false)
    const token = localStorage.getItem("token")
    if (!token) {
      return navigate("/connect-wal")
    }

    // If already verified this session
    if (localStorage.getItem("passwordVerified") === "true") {
      return navigate("/Lookna-wallet")
    }

    // Otherwise, check token validity
    try {
      const headers = { Authorization: `Bearer ${token}` }
      await Promise.all([
        axios.get(
          "https://looknatest.com/wallet/wallet/getAssetsByChain?chainId=1",
          { headers }
        ),
        axios.get(
          "https://looknatest.com/wallet/wallet/getPublicKeyEvmGenerated",
          { headers }
        ),
      ])

      setIsConnectModalOpen(true)
    } catch (err) {
      if (err?.response?.status === 403) {
        navigate("/connect-wal")
      } else {
        toast.error("Cannot access wallet. Try again.")
      }
    }
  }

  return (
    <div>
      <div className={`side-navbar ${isOpen ? "open" : "closed"}`}>
        <ul className="nav-items">
          <li className="nav-item" onClick={() => handleNavigate("/home")}>
            <img src="/home.png" className="nav-icon" alt="Home" />
            <span className="nav-text">Home</span>
          </li>
 <li className="nav-item" onClick={() => handleNavigate("/Profile")}>
            <img
              src="/vector-10.png"
              className="nav-icon"
              alt="Centralized Exchange"
            />
            <span className="nav-text">Profile</span>
          </li>
          <li className="nav-item" onClick={handleWalletClick}>
            <img src="/wallet-icon.png" className="nav-icon" alt="Wallet" />
            <span className="nav-text">Wallet</span>
          </li>

          <li
            className="nav-item"
            onClick={() => handleNavigate("/check-scam")}
          >
            <img
              src="/Vector-6.png"
              className="nav-icon"
              alt="Scam Token Identifier"
            />
            <span className="nav-text">Scam Token Identifier</span>
          </li>

          <li className="nav-item" onClick={() => handleNavigate("/CEX")}>
            <img
              src="/Vector-1.png"
              className="nav-icon"
              alt="Centralized Exchange"
            />
            <span className="nav-text">Centralized Exchange</span>
          </li>

         
          <li className="nav-item" onClick={() => handleNavigate("/DEX")}>
            <img
              src="/Vector-2.png"
              className="nav-icon"
              alt="Decentralized Exchange"
            />
            <span className="nav-text">Decentralized Exchange</span>
          </li>

          <li
            className="nav-item"
            onClick={() => handleNavigate("/private-sale")}
          >
            <img
              src="/Vector-4.png"
              className="nav-icon"
              alt="Private Sale"
            />
            <span className="nav-text">Private Sale</span>
          </li>

              {/* <li
            className="nav-item"
            onClick={() => handleNavigate("/Education-Section")}
          >
            <img
              src="/vector-new.png"
              className="nav-icon"
              alt="Education-Section"
            />
            <span className="nav-text">Education Section</span>
          </li> */}

          <li className="nav-item" onClick={() => handleNavigate("/watch-list")}>
            {/* <div className="favorite-icon"> */}
              <img src="/Vector-fav.png" alt="My Watch List" className="nav-icon" />
            {/* </div> */}
            <span className="nav-text">My Watch List</span>
          </li>
          <li className="nav-item" onClick={() => handleNavigate("/Terms-and-Condition")}>
            <img
              src="/vector-8.png"
              className="nav-icon"
              alt="Centralized Exchange"
            />
            <span className="nav-text">Terms and Conditions</span>
          </li>
<li className="nav-item" onClick={() => handleNavigate("/Privacy-Policy")}>
            <img
              src="/vector-9.png"
              className="nav-icon"
              alt="Centralized Exchange"
            />
            <span className="nav-text">Privacy-Policy</span>
          </li>

          <li className="nav-item" onClick={handleLogout}>
            <img
              src="/log-out.png"
              className="nav-icon-log"
              alt="Logout"
            />
            <span className="nav-text">Logout</span>
          </li>
        </ul>
      </div>

      <div className="toggle-button" onClick={toggleNavbar}>
        {isOpen ? "☰" : "☰"}
      </div>

      {isConnectModalOpen &&
        (localStorage.getItem("passwordVerified") === "true" ? (
          <ConnectModal onClose={() => setIsConnectModalOpen(false)} />
        ) : (
          <SetPassword onClose={() => setIsConnectModalOpen(false)} />
        ))}
    </div>
  )
}

export default SideNavbar
